// Hooks / Node modules / Styles
import { VerticalTimeline } from "react-vertical-timeline-component";
import { motion } from "framer-motion";

import "react-vertical-timeline-component/style.min.css";

// Reducers / Actions

// Utils / Functions
import { textVariant } from "src/utils/framer-motion/motion";

// Components

// Sub-Components
import ComponentContainer from "../ComponentContainer";
import ExperienceCard from "./com/ExperienceCard";

// Data / Images / Icons
import { EXPERIENCES } from "src/data/pages/experinces";

// export const EXPERIENCES = [
//   {
//     title: "Software Engineer",
//     company_name: "Company A",
//     date: "Jan 2022 - Present",
//     icon: "path/to/logo.png",
//     iconBg: "#000",
//     points: [
//       "Developed web applications using React",
//       "Collaborated with the design team",
//     ],
//   },
//   {
//     title: "Web Developer",
//     company_name: "Company B",
//     date: "Jun 2020 - Dec 2021",
//     icon: "path/to/logo2.png",
//     iconBg: "#123456",
//     points: [
//       "Worked on front-end development using HTML, CSS, JavaScript",
//       "Optimized web pages for performance",
//     ],
//   },
// ];

function Experience() {
  return (
    <ComponentContainer
      title="Work Experience"
      subtitle="What I have done so far"
    >
      <div className="mt-10">
        <VerticalTimeline>
          {EXPERIENCES.map((experience, index) => (
            <ExperienceCard
              key={`experience-${index}`}
              experience={experience}
            />
          ))}
        </VerticalTimeline>
      </div>
    </ComponentContainer>
  );
}

export default Experience;
